export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "collection_items_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["수거 품목"])}
    }
  })
}
